// eslint-disable-next-line import/prefer-default-export
export const getFastInstrumentType = (state) => state.aboutState.fastInstrumentType;
